/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser>): BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser(), model);
        BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser>): BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.newInstance(<BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
